module.exports = __webpack_public_path__ + "static/media/pos-banner.c5885174.jpg";